import { Dayjs } from 'dayjs'
import { IDataByDay } from '../selectors'

export const getDetailTaskItemData = (value: Dayjs, dataByDay: IDataByDay) => {
  const currentDate = value.format('YYYY.MM.DD')
  if (!dataByDay[currentDate]) {
    return []
  }
  return dataByDay[currentDate]?.filter(val => val?.stage !== 'done')
}
